"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.form.title.label': 'Question Title <span class="text-danger">*</span>',
    'question.form.title.placeholder': 'Enter question title',
    'question.form.type.label': 'Question Type',
    'question.form.type.placeholder': 'Select question type',
    'question.form.required.label': 'Required',
    'question.form.description.label': 'Description (Optional)',
    'question.form.description.placeholder': 'Enter question description',
    'question.form.options.label': 'Options',
    'question.form.options.add': 'Add Option',
    'question.form.option.value.placeholder': 'Option value',
    'question.form.option.label.placeholder': 'Option label',
    'question.form.option.remove': 'Remove option',
    'question.form.options.empty': 'No options added yet. Click "Add Option" to get started.',
};
